<template>
  <div class="home">
    <h1 class="mb-5">NJCRIB Manage Ownership</h1>
    <b-card-group deck class="col-lg-6 mx-auto">
    <router-link v-if="!isDCOUser" :to="{ name: 'submission/create' }" class="card left hover" :style="cardStyle">
      <b-card-body>
        <h4 class="mb-4">Create and Submit a New NJCRIB ERM-14 Form</h4>
        <i class="fas fa-4x fa-plus-circle text-success"></i>
      </b-card-body>
    </router-link>
    <router-link :to="{ name: 'submission/list' }" class="card right hover" :style="cardStyle">
        <b-card-body>
          <h4 class="mb-4">{{ isDCOUser ? 'Search NJCRIB ERM-14 Forms' : 'My NJCRIB ERM-14 Forms' }}</h4>
          <i class="fas fa-4x fa-folder-open text-success"></i>
        </b-card-body>
    </router-link>
    </b-card-group>
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
      return {
        cardStyle: {
          display: 'inline-block',
          marginBottom: '1rem',
          marginLeft: 'auto',
          marginRight: 'auto',
          padding: '1rem',
          color: 'black',
          border: 'none',
          borderLeft: '8px solid #28a745',
          borderRadius: '.5rem'
        }
    }
  },
  computed: {
    isDCOUser() {
      return this.$store.getters['user/isDCOUser']
    }
  }
}
</script>

<style scoped>
.home {
  padding-top: 3rem;
}

.home h1 {
  font-family: 'Noto Sans JP', sans-serif;
  font-size: 54px;
  margin-top: 2rem;
}

@media (min-width: 576px) {
  .left {
    margin-right: 0.5rem !important;
  }

  .right {
    margin-left: 0.5rem !important;
  }
}
</style>